import { useLoading } from '@gorila-shared-ui/components';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { getGptEvent } from '../../../services/gptService';
import { eventDetailState } from '../../../storage/gpt';

export function useGptEventDetail() {
  const { eventId } = useParams();
  const [event, setEvent] = useRecoilState(eventDetailState);
  const { startLoading, stopLoading, loading } = useLoading();
  const navigate = useNavigate();

  useEffect(() => {
    if (!eventId) return;

    const loadEvent = async () => {
      startLoading();
      const { event, error } = await getGptEvent(eventId);
      if (event && !error) {
        setEvent(event);
      } else {
        setEvent(undefined);
        navigate('/404', { replace: true });
      }
      stopLoading();
    };

    loadEvent();
  }, [eventId]);

  return {
    event,
    loadingEvent: loading,
  };
}
